export async function fetchExternalImageAsFile(url, filenameBase = "cover-art") {
  const res = await fetch(url, { mode: "cors" }); // requires CORS from the host
  if (!res.ok) throw new Error(`Failed to fetch image: ${res.status}`);

  const contentType = res.headers.get("content-type") || "image/jpeg";
  const blob = await res.blob();

  const ext = contentType.includes("png")
    ? "png"
    : contentType.includes("webp")
    ? "webp"
    : contentType.includes("gif")
    ? "gif"
    : "jpg";

  const safe = (s) => (s || "cover-art").toString().toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return new File([blob], `${safe(filenameBase)}.${ext}`, { type: contentType });
}